import { get } from "lodash"
import { OkReduxDataResult } from "model/state"

// [TODO] These probably belong somewhere else, but I don't where yet
export type CompositionType = typeof LONG | typeof SHORT | typeof LONG_SHORT

export const LONG_SHORT = "LONG_SHORT"
export const OVERWEIGHT_UNDERWEIGHT = "OVERWEIGHT_UNDERWEIGHT"
export const SHORT = "SHORT"
export const LONG = "LONG"

export type CompositionByNode = {
  id: (typeof LONG | typeof SHORT)
}[]

export interface CompositionTypeData {
  model: {
    simulation: {
      composition: {
        compositionBy: CompositionByNode
      }[]
    }
  }
}

export function getCompositionType(data: OkReduxDataResult<CompositionTypeData>): CompositionType {
  const groupIds = get(data, "data.model.simulation.composition.0.compositionBy")

  // If there's a single item, that's our type
  // groupIds can be undefined if instrument is not found
  if (groupIds?.length === 1) {
    return groupIds[0].id
  }

  // If there's more than one, or if we don't know, assume long/short
  return LONG_SHORT
}
